// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, post } from "@insite/client-framework/Services/ApiService";
import { GenticKitsActivateObjectModel } from "@rc/App/Widgets/ActivateGeneticKit/ActivateGeneticKit";
import { GenericKitModel, NotifyKitModel } from "@rc/App/Widgets/GeneticKit/GeneticKit";

const rcCustomerKits = "api/genetickits/getcustomerkits";
const rcSearchCustomerKits = "api/genetickits/searchkit";
const rcNotifyKit = "api/genetickits/notifykit";
const rcCustomerKitById = "/api/genetickits/getkit";
const rcActivatekit = "api/genetickits/activatekit";
const rcModifykit = "api/genetickits/modifykit";

export function xngGetRcCustomerKits() {
    return get<any>(rcCustomerKits);
}

export function xngSearchRcCustomerKits(parameter: GenericKitModel) {
    return post<GenericKitModel, any>(rcSearchCustomerKits, parameter);
}

export function xngNotifyKit(parameter: NotifyKitModel) {
    return post<any>(rcNotifyKit, parameter);
}

export function xngGetCustomerKitById(KitId: string) {
    return get<any>(`${rcCustomerKitById}?KitId=${KitId}`);
}

export function xngActivateCustomerKit(parameter: GenticKitsActivateObjectModel) {
    return post<any>(rcActivatekit, parameter);
}

export function xngUpdateCustomKit(parameter: GenticKitsActivateObjectModel) {
    return post<any>(rcModifykit, parameter);
}